export const CLINICAL_DOCUMENT_TYPE_LABELS: Record<string, string> = {
  initial_treatment_plan: "Initial Treatment Plan",
  reassessment_treatment_plan: "Reassessment Treatment Plan",
};

export const CLINICAL_DOCUMENT_TYPE_OPTIONS = Object.entries(CLINICAL_DOCUMENT_TYPE_LABELS).map(
  ([value, label]) => ({ value, label })
);

export const ASSESSMENT_TYPE_LABELS: Record<string, string> = {
  VINELAND: "Vineland",
  CFQL2: "CFQL-2",
  VBMAPP_MILESTONES: "VB-MAPP Milestones",
  AFLS: "AFLS",
  VBMAPP_BARRIERS: "VB-MAPP Barriers",
  VBMAPP_TRANSITION: "VB-MAPP Transition",
  SOCIALLY_SAVVY: "Socially Savvy",
  SRS2: "SRS-2",
  PEAK: "PEAK",
  ESSENTIAL_FOR_LIVING: "EFL",
  QABF: "QABF",
  CPFQ_CHILD: "CPFQ - Child",
  CPFQ_CAREGIVER: "CPFQ - Caregiver",
};

export const ASSESSMENT_TYPE_OPTIONS = Object.entries(ASSESSMENT_TYPE_LABELS).map(
  ([value, label]) => ({ value, label })
);

export const OPERATOR_OPTIONS = [
  { value: "AND", label: "AND (all required)" },
  { value: "OR", label: "OR (any one required)" },
];
